module.exports = " <div class=counpon v-for=\"item in couponlist\" @click=go(item)> <span class=name>{{item.name}}</span> <span class=price v-if=item.price> <b>{{item.price}}</b>元</span> <span class=price v-if=item.discount> <b>{{item.discount}}</b>折</span> <span class=date>{{item.starttime | filterTime}}-{{item.endtime | filterTime}}</span> <span class=btn v-if=item.url>去使用</span> <img src=//static.djtest.cn/fe/other/lx20170226/newcoupon/img/coupon.png alt=\"\"> <div class=img-shade></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Success.vue
// module id = 150
// module chunks = 0